'use strict';

var Caml_builtin_exceptions = require("./caml_builtin_exceptions.js");

function get(s, i) {
  if (i < 0 || i >= s.length) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "index out of bounds"
        ];
  } else {
    return s[i];
  }
}

exports.get = get;
/* No side effect */



//////////////////
// WEBPACK FOOTER
// /home/main/n/lib/node_modules/bs-platform/lib/js/caml_bytes.js
// module id = 106
// module chunks = 0